export default "__VITE_ASSET__DuK890Za__"